import { useTranslation } from 'react-i18next';

import { BackButtonStyled } from './AddYourDocumentsStyled';
import { AddYourDocumentsCard } from './components/AddYourDocumentsCard';
import { BackButton } from '../Shared/BackButton';
import { PageContentHeaderDisplay } from 'enrollment/components';

export const AddYourDocuments = () => {
  const { t } = useTranslation('pages.addYourDocuments');

  return (
    <>
      <nav aria-label={t('commmon:navigateToPrevious')}>
        <BackButtonStyled>
          <BackButton label={t('common:back')} />
        </BackButtonStyled>
      </nav>
      <main id="mainContent">
        <h1>{t('title')}</h1>

        <div className="mb-4">
          <PageContentHeaderDisplay
            pageContentLookupCode="sub_main/document_library"
            displayPageHeader={false}
          />
        </div>
        <AddYourDocumentsCard />
      </main>
    </>
  );
};
